import { useState, useEffect } from 'react'

export const useIsVisible = (ref: React.RefObject<HTMLElement>) => {
    const [isVisible, setIsVisible] = useState<boolean>(false)

    useEffect(() => {
        const element = ref.current
        if (!element) {
            return
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
            },
            {
                threshold: 0.1, // Adjust this value as needed
            }
        )

        observer.observe(element)

        return () => {
            observer.unobserve(element)
            observer.disconnect()
        }
    }, [ref])

    return isVisible
}
